import React, { Component } from 'react';
import { Checkbox, Panel, ActionButton } from '@fluentui/react';
import { useNavigate, useParams } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui.min';
import 'jquery-ui/dist/themes/base/jquery-ui.css';
import { withRouter } from '../../WithRouter';

class ColumnSelector extends Component {
    static displayName = ColumnSelector.name;

    constructor(props) {
        super(props);
        this.state = {
            gridRef: props.gridRef
        };
    }

    componentDidMount() {
    }

    open = () => {
        this.setState(
            {
                isOpen: true
            });
    };

    close = () => {
        this.setState({ isOpen: false });
    }

    toggleColumn(columnId, showColumn) {
        this.state.gridRef.current.columnApi.applyColumnState({ state: [{ colId: columnId, hide: !showColumn }] });
        this.state.gridRef.current.api.sizeColumnsToFit();
        this.state.gridRef.current.api.resetRowHeights();
    }

    componentDidMount() {
    }

    render() {
        var iconProps = { iconName: 'TripleColumn' };
        return (
            <div id="column-selector-option" className="filter-control" onClick={this.open}>
                <ActionButton id="column-selector-button" iconProps={iconProps}>Column&nbsp;selector</ActionButton>

                <Panel
                    isOpen={this.state.isOpen}
                    isLightDismiss
                    isHiddenOnDismiss={true}
                    onDismiss={this.close}
                    headerText='Select columns'>
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <Checkbox id='show-column-licensekey' label='License Key' onChange={e => {
                                        this.toggleColumn('licenseKey', e.target.checked);
                                    }} />
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <Checkbox id='show-column-aiassistant' defaultChecked label='AI Assistant' onChange={e => {
                                        this.toggleColumn('featureGPT', e.target.checked);
                                    }} />
                                </td>
                            </tr>
                        <tr>
                            <td>
                                <Checkbox id='show-column-customai' label='Custom AI' onChange={e => {
                                        this.toggleColumn('featureCustomAI', e.target.checked);
                                    }} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Checkbox id='show-column-supershot' defaultChecked label='AI Report' onChange={e => {
                                        this.toggleColumn('featureSuperShot', e.target.checked);
                                    }}></Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Checkbox id='show-column-patentdrafting' defaultChecked label='Patent Drafting' onChange={e => {
                                        this.toggleColumn('featurePatentDrafting', e.target.checked);
                                    }}></Checkbox>
                            </td>
                        </tr>
                            <tr>
                                <td>
                                    <Checkbox id='show-column-standardmapping' defaultChecked label='Standard Mapping' onChange={e => {
                                        this.toggleColumn('featureStandardMapping', e.target.checked);
                                    }}></Checkbox>
                                </td>
                            </tr>
                        <tr>
                            <td>
                                <Checkbox id='show-column-epomirror' label='Azure EPO Mirror' onChange={e => {
                                        this.toggleColumn('featureEPOMirror', e.target.checked);
                                    }}></Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Checkbox id='show-column-speech' label='Speech Assistant' onChange={e => {
                                        this.toggleColumn('featureSpeech', e.target.checked);
                                    }}></Checkbox>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Panel>
            </div>
        );
    }
}

export default withRouter(ColumnSelector);
